import {
  Autocomplete,
  Avatar,
  Button,
  MenuItem,
  Modal,
  Select,
  TablePagination,
  TextField,
  Typography,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayoutCustom2 from "examples/LayoutContainers/DashboardLayoutCustom2";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from "react";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import MessageIcon from "@mui/icons-material/Message";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import MDInput from "components/MDInput";
import { useDispatch, useSelector } from "react-redux";
import { chatbotRAmomentssSggestionAsync } from "features/actions/auth";
import toast from "react-hot-toast";
import { getContactAsync } from "features/actions/auth";
import { getMomentAsync } from "features/actions/auth";
import { getOfferAsync } from "features/actions/auth";
import { sendEmailAsync } from "features/actions/auth";
import { sendMomentEmailAsync } from "features/actions/auth";
import { updateMomentStatusAsync } from "features/actions/auth";

const RaMoment = () => {
  const dispatch = useDispatch();
  const {
    RAMoments,
    requestGenericRequest,
    getprofile,
    MomentData,
    offerData,
  } = useSelector((state) => state.auth);
  const credtedById = offerData?.list?.[0]?.createdById;
  const [loading, setLoading] = useState(false);
  const [RAMomentsData, setRAMomentsData] = useState();
  const [occasionValue, setOccasionValue] = useState(null);
  const [zipValue, setZipValue] = useState(null);
  const [open, setOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [visibleCount, setVisibleCount] = useState(10);
  const [localRAMoment, setLocalRAMoment] = useState("");
  const [newtemplate, setNewTemplate] = useState("");
  const [templateData, setTemplateData] = useState({
    name: "",
    info: "",
  });
  const [selectedTemplateId, setSelectedTemplateId] = useState("");

  const handleTemplateSelect = (event) => {
    const selectedId = event.target.value;
    setSelectedTemplateId(selectedId);

    const selectedOffer = offersToShow.find(
      (option) => option.id === selectedId
    );
    if (selectedOffer) {
      setTemplateData({
        ...templateData,
        name: selectedOffer.name,
        info: selectedOffer.description,
      });
    }
  };
  const handleTemplateChange = (e) => {
    const { name, value } = e.target;
    setTemplateData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmitTemplate = () => {
    if (!offerData?.list || offerData.list.length === 0) {
      toast.success("This is sample data"); // show toast
      return;
    }
    if (!templateData.name || !templateData.info) {
      toast.error("Please fill all required fields");
      return;
    }
    const payload = {
      user_id: credtedById,
      offer: "10% off on your next purchase!",
      name: templateData.name,
      info: templateData.info,
    };
    dispatch(sendEmailAsync({ payload })).then(() => {
      toast.success("Template Add Successfully!");
      dispatch(getOfferAsync({ username }));
    });
    setNewTemplate(false);
  };

  const handleAddTemplate = () => {
    setNewTemplate(true);
  };

  const handleOpen = (user) => {
    setSelectedUser(user);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedUser(null);
    setFormData({ suggestion: "" });
    setLocalRAMoment(false);
    setNewTemplate(false);
  };

  const [formData, setFormData] = useState({
    name: "",
    date: "",
    dob: "",
    suggestion: "",
  });

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async () => {
    const businessId = localStorage.getItem("common_id");
    const payload = {
      customer_info: {
        name: selectedUser?.name || "",
        date: selectedUser?.date || "",
        moment: selectedUser?.dob || "",
        description: selectedUser?.description || "",
      },
      offer_info: formData.suggestion || "",
      business_id: businessId,
    };

    try {
      setLoading(true);
      dispatch(chatbotRAmomentssSggestionAsync(payload)).then(() => {
        setLocalRAMoment(true);
        setLoading(false);
      });
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      toast.error("Something went wrong. Please try again.");
      setLoading(false);
    }
  };

  const options = [
    { label: "Option 1", value: "option1" },
    { label: "Option 2", value: "option2" },
    { label: "Option 3", value: "option3" },
  ];

  const handleMessageClick = () => {
    toast.success("Invitation sent!");
  };
  const handleEmailClick = () => {
    toast.success("Invitation sent!");
  };

  useEffect(() => {
    if (RAMoments) {
      setRAMomentsData(RAMoments);
    }
  }, [RAMoments]);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const totalCount = MomentData?.total || 0;

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // reset to first page when changing rows
  };

  const username = getprofile?.userProfile?.username;
  const offset = page * rowsPerPage;
  const handleSubmitforSendEmail = () => {
    const payload = {
      moment_id: selectedUser?.id,
      subject: formData?.suggestion,
      body: `${RAMomentsData || ""}${
        requestGenericRequest?.business?.booking_link
          ? `\n\nBook Now :- ${requestGenericRequest.business.booking_link}`
          : ""
      }`,
    };
    const id = selectedUser?.id;
    const payloadMomemt = { status: "inProgress" };
    dispatch(sendMomentEmailAsync({ payload })).then(() => {
      dispatch(
        updateMomentStatusAsync({ id, username, payload: payloadMomemt })
      );
      toast.success("Email sent successfully!");
      dispatch(getMomentAsync({ username, maxSize: rowsPerPage, offset }));
    });
    setOpen(false);
  };

  const handleSubmitforFollowUp = (user) => {
    const id = user?.id;
    const payloadMomemt = { noOfRequest: (user.noOfRequest || 0) + 1 };
    dispatch(
      updateMomentStatusAsync({ id, username, payload: payloadMomemt })
    ).then(() => {
      toast.success("Follow Up successfully!");
      dispatch(getMomentAsync({ username, maxSize: rowsPerPage, offset }));
    });
  };
  const sampleOffers = [
    { id: 1, name: "Christmas Offer", description: "25% off on cake" },
    { id: 2, name: "Diwali Offer", description: "50% off on cake" },
  ];

  const sampleData = [
    {
      name: "New test A",
      description: "Free",
      createdAt: "2025-09-11",
      status: "inProgress",
      noOfRequest: 1,
      isDummy: true,
    },
    {
      name: "New test B",
      description: "Premium",
      createdAt: "2025-09-15",
      status: "completed",
      noOfRequest: 3,
      isDummy: true,
    },
    {
      name: "New test C",
      description: "Free Trial",
      createdAt: "2025-09-20",
      status: "pending",
      noOfRequest: 2,
      isDummy: true,
    },
    {
      name: "New test D",
      description: "Basic",
      createdAt: "2025-09-25",
      status: "inProgress",
      noOfRequest: 5,
      isDummy: true,
    },
    {
      name: "New test E",
      description: "Enterprise",
      createdAt: "2025-10-01",
      status: "completed",
      noOfRequest: 4,
      isDummy: true,
    },
  ];

  const listToRender =
    MomentData?.list?.length > 0 ? MomentData.list : sampleData;
  const offersToShow =
    offerData?.list && offerData.list.length > 0
      ? offerData.list
      : sampleOffers;

  useEffect(() => {
    if (username) {
      dispatch(getMomentAsync({ username, maxSize: rowsPerPage, offset }));
      dispatch(getOfferAsync({ username }));
    }
  }, [page, rowsPerPage, username, dispatch]);
  return (
    <MDBox sx={{ backgroundColor: "#f9f9f9", minHeight: "100vh" }}>
      <DashboardLayoutCustom2>
        {/* {loading && <Loader />} */}
        <DashboardNavbar />
        <MDBox
          sx={{
            px: {
              xs: 1.5,
              sm: "1rem",
            },
          }}
        >
          <MDBox
            sx={{
              py: 1,
              borderRadius: "20px",
              height: "auto",
              boxShadow: "0px 1px 6px rgba(0,0,0,0.1)",
              backgroundColor: "#ffffff",
              mb: 4,
            }}
          >
            <MDBox
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #E1EAFF",
                px: 2,
                py: 1,
              }}
            >
              <MDTypography
                mt={2}
                mb={2}
                sx={{
                  fontSize: {
                    xs: "12px",
                    sm: "24px",
                  },
                  width: {
                    xs: "75%",
                    sm: "85%",
                  },
                  color: "#292929",
                  fontFamily: "Urbanist",
                  fontWeight: 700,
                  lineHeight: "28.8px",
                }}
              >
                Curated Local Guests with specials Ocassions.
              </MDTypography>
              <Button
                variant="contained"
                sx={{
                  cursor: "pointer",
                  borderRadius: "45px",
                  backgroundColor: "#318BEC",
                  fontFamily: "urbanist",
                  textTransform: "capitalize",
                  width: {
                    xs: "29%",
                    sm: "15%",
                  },
                  fontSize: {
                    xs: "11px",
                    sm: "14px",
                  },
                  px: {
                    xs: 1,
                    sm: 2,
                  },
                  color: "#fff",
                  textTransform: "capitalize",
                }}
              >
                Download All
              </Button>
            </MDBox>

            <MDBox
              sx={{
                px: {
                  xs: 1.5,
                  sm: 4,
                },
                py: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <MDBox
                sx={{
                  width: "50%",
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <MDBox
                  sx={{
                    width: {
                      xs: "50%",
                      sm: "50%",
                      md: "50%",
                    },
                  }}
                >
                  <Autocomplete
                    value={occasionValue}
                    onChange={(event, newValue) => {
                      setOccasionValue(newValue);
                    }}
                    options={options}
                    getOptionLabel={(option) => option.label}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Occasion Type"
                        variant="outlined"
                      />
                    )}
                  />
                </MDBox>

                <MDBox
                  sx={{
                    width: {
                      xs: "50%",
                      sm: "50%",
                      md: "50%",
                    },
                  }}
                >
                  <Autocomplete
                    value={zipValue}
                    onChange={(event, newValue) => {
                      setZipValue(newValue);
                    }}
                    options={options}
                    getOptionLabel={(option) => option.label}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Zip Code"
                        variant="outlined"
                      />
                    )}
                  />
                </MDBox>
              </MDBox>
              <Button
                variant="contained"
                sx={{
                  cursor: "pointer",
                  borderRadius: "45px",
                  backgroundColor: "#318BEC",
                  fontFamily: "urbanist",
                  textTransform: "capitalize",
                  width: {
                    xs: "25%",
                    sm: "15%",
                  },
                  fontSize: {
                    xs: "11px",
                    sm: "14px",
                  },
                  px: {
                    xs: 1,
                    sm: 2,
                  },
                  color: "#fff",
                  textTransform: "capitalize",
                }}
                onClick={() => handleAddTemplate()}
              >
                Send Offer
              </Button>
            </MDBox>

            <MDBox
              sx={{
                pb: 1,
                px: {
                  xs: 1.5,
                  sm: 4,
                },
              }}
            >
              <MDTypography
                sx={{
                  color: "#292929",
                  fontFamily: "Urbanist",
                  fontSize: "18px",
                  fontWeight: 700,
                  lineHeight: "28.8px",
                }}
              >
                Upcommimg Celebrations
                {MomentData?.list?.length === 0 && (
                  <span
                    style={{ color: "red", fontWeight: 400, marginLeft: "8px" }}
                  >
                    (Sample Data)
                  </span>
                )}{" "}
              </MDTypography>
            </MDBox>
            <MDBox
              sx={{
                width: "95%",
                margin: "auto",
                borderRadius: "10px",
                border: "1px solid #E1EAFF",
                height: "auto",
                overflowY: "auto",
              }}
              // onScroll={handleScroll}
            >
              {listToRender.slice(0, visibleCount).map((user, index) => (
                <MDBox
                  key={index}
                  sx={{
                    width: "100%",
                    margin: "auto",
                    flexDirection: "column",
                    // gap: 2,
                    px: 2,
                    py: 2,
                    display: "flex",
                    alignItems: "start",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #E1EAFF",
                    "@media(min-width:425px)": {
                      display: "flex",
                      alignItems: "start",
                      justifyContent: "space-between",
                      flexDirection: "column",
                    },
                  }}
                >
                  <MDBox
                    sx={{
                      width: "100%",
                      margin: "auto",
                      flexDirection: "row",
                      gap: 2,
                      // px: 4,
                      //   py: 2,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      "@media(min-width:425px)": {
                        display: "flex",
                        alignItems: "start",
                        gap: 1,
                        justifyContent: "space-between",
                      },
                    }}
                  >
                    {/* Left Side: Header Block */}
                    <MDBox
                      sx={{
                        width: {
                          xs: "70%", // <600px
                          sm: "25%", // ≥600px
                        },
                        display: "flex",
                        alignItems: "flex-start",
                        textAlign: "start",
                        gap: "15px",
                      }}
                    >
                      {/* <Avatar
                        src={user.avatar}
                        sx={{
                          width: 54,
                          height: 54,
                          mb: 1,
                        }}
                      >
                        {user.name?.charAt(0)}
                      </Avatar> */}

                      <MDBox>
                        <Typography
                          variant="h5"
                          sx={{
                            fontSize: {
                              xs: "14px",
                              sm: "18px",
                            },
                          }}
                          color="#000"
                        >
                          {user.name}
                          {/* {`${user.firstName} ${user.lastName}`} */}
                        </Typography>

                        <Typography
                          variant="body2"
                          sx={{
                            fontSize: {
                              xs: "12px",
                              sm: "14px",
                            },
                          }}
                          color="#000"
                        >
                          {user.dob}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            fontSize: {
                              xs: "12px",
                              sm: "14px",
                            },
                            display: {
                              xs: "block", // visible on mobile
                              sm: "none", // hidden on >= small
                            },
                          }}
                        >
                          {" "}
                          {/* {user.date} */}
                          {new Date(user.modifiedAt).toLocaleDateString()}
                        </Typography>
                      </MDBox>
                    </MDBox>

                    <MDBox
                      sx={{
                        width: {
                          sm: "30%",
                        },
                        display: {
                          xs: "none",
                          sm: "block",
                        },
                      }}
                    >
                      <Typography variant="body2">
                        {/* {user.date} */}
                        {new Date(user.createdAt).toLocaleDateString()}
                      </Typography>
                    </MDBox>
                    <MDBox
                      sx={{
                        width: {
                          sm: "20%",
                        },
                        display: {
                          xs: "none",
                          sm: "block",
                        },
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          mt: {
                            xs: 0,
                            sm: 0,
                          },
                        }}
                      >
                        {user.status === "inProgress" && (
                          <>
                            <strong>Status :</strong> inProgress
                          </>
                        )}
                      </Typography>
                    </MDBox>

                    <MDBox
                      sx={{
                        width: {
                          sm: "20%",
                        },
                        display: {
                          xs: "none",
                          sm: "block",
                        },
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          mt: {
                            xs: 0,
                            sm: 0,
                          },
                        }}
                      >
                        {user.noOfRequest > "0" && (
                          <>
                            <strong>No. of Request :</strong> {user.noOfRequest}
                          </>
                        )}
                      </Typography>
                    </MDBox>
                    <MDBox
                      sx={{
                        mt: 1,
                        width: {
                          xs: "50%",
                          sm: "30%",
                        },
                        "@media(min-width:425px)": { width: "15%" },
                      }}
                    >
                      <Button
                        variant="contained"
                        size="small"
                        className="UserContactButton"
                        sx={{
                          fontSize: {
                            xs: "12px",
                            sm: "14px",
                          },
                          "@media (min-width:425px)": {
                            px: 2,
                            width: "100%",
                          },
                        }}
                        // onClick={() =>
                        //   user.status === "inProgress"
                        //     ? handleSubmitforFollowUp(user)
                        //     : handleOpen(user)
                        // }
                        onClick={() => {
                          if (user.isDummy) {
                            toast.success("This is sample data"); // 👈 show toast if dummy
                          } else {
                            user.status === "inProgress"
                              ? handleSubmitforFollowUp(user)
                              : handleOpen(user);
                          }
                        }}
                      >
                        {user.status === "inProgress"
                          ? "Follow Up"
                          : "  Send Offer"}
                      </Button>
                    </MDBox>
                  </MDBox>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: {
                        xs: "12px",
                        sm: "14px",
                      },
                      mt: {
                        xs: 0,
                        sm: 0,
                      },
                    }}
                  >
                    <strong>Suggestiod :</strong> {user.description}
                  </Typography>
                </MDBox>
              ))}

              {MomentData?.list?.length > 0 ? (
                <TablePagination
                  sx={{
                    fontFamily: "urbanist",
                    fontWeight: "700",
                    "& .css-p33a0u-MuiTablePagination-selectLabel": {
                      fontFamily: "urbanist",
                      fontWeight: "500",
                    },
                    "& .css-r9d6bn-MuiSelect-select-MuiInputBase-input": {
                      fontFamily: "urbanist",
                      fontWeight: "600",
                    },
                    "& .css-188flkz-MuiTablePagination-displayedRows": {
                      fontFamily: "urbanist",
                      fontWeight: "500",
                    },
                  }}
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={totalCount}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handlePageChange}
                  onRowsPerPageChange={handleRowsPerPageChange}
                />
              ) : (
                <></>
              )}
            </MDBox>
          </MDBox>
        </MDBox>
      </DashboardLayoutCustom2>

      {/* //Modal */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <MDBox
          className="main_modal"
          sx={{
            position: "absolute",
            top: {
              xs: "30%",
              sm: " 50%",
            },
            //   top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: {
              xs: "90%",
              sm: 400,
              md: 500,
            },
            bgcolor: "background.paper",
            boxShadow: 24,
            p: {
              xs: 2,
              sm: 3,
              md: 4,
            },
            borderRadius: 2,
            maxHeight: "90vh",
            overflowY: "auto",
          }}
        >
          {selectedUser && (
            <>
              {/* Header */}
              <MDBox
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "start",
                  flexWrap: "wrap",
                  gap: 1,
                  px: 2,
                  py: 1,
                  borderBottom: "1px solid #E1EAFF",
                  backgroundColor: "#348BEC",
                }}
              >
                <Typography
                  variant="h5"
                  component="h2"
                  sx={{ wordBreak: "break-word", color: "#fff" }}
                >
                  Contact Info for {selectedUser.name}
                </Typography>
                <IconButton
                  className="closeIcon"
                  sx={{ color: "#fff" }}
                  onClick={handleClose}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </MDBox>

              {/* Body */}
              <MDBox className="Ra_modal">
                <MDBox
                  sx={{
                    display: "flex",
                    gap: "5px",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "16px",
                        sm: "16px",
                      },
                    }}
                  >
                    <strong>Name:</strong> {selectedUser.name || "N/A"}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "16px",
                        sm: "16px",
                      },
                    }}
                  >
                    <strong>Moment:</strong>{" "}
                    {new Date(selectedUser.modifiedAt).toLocaleDateString() ||
                      "N/A"}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "16px",
                        sm: "16px",
                      },
                    }}
                  >
                    <strong>Date:</strong>{" "}
                    {new Date(selectedUser.createdAt).toLocaleDateString() ||
                      "N/A"}
                  </Typography>
                </MDBox>
                <Typography
                  sx={{
                    fontSize: {
                      xs: "16px",
                      sm: "16px",
                    },
                  }}
                >
                  <strong>Info:</strong> {selectedUser.description || "N/A"}
                </Typography>
                <MDBox
                  sx={{
                    display: "flex",
                    gap: "10px",
                    justifyContent: "start",
                    alignItems: "center",
                  }}
                >
                  <MDInput
                    type="text"
                    placeholder="Enter your offer"
                    value={formData.suggestion}
                    onChange={(e) => handleChange("suggestion", e.target.value)}
                    fullWidth
                    disabled={loading}
                    className="RA_input"
                    sx={{
                      width: "58%",
                      backgroundColor: "#fff",
                      borderRadius: "24px",
                      color: "#fff",
                      mt: 2,
                      "& .MuiInputBase-root": {
                        borderRadius: "45px",
                        paddingRight: "41px",
                      },
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "45px",
                      },
                    }}
                  />
                  <Button
                    variant="contained"
                    size="medium"
                    onClick={handleSubmit}
                    disabled={loading}
                    sx={{
                      mt: 2,
                      color: "#fff",
                      cursor: "pointer",
                      borderRadius: "45px",
                      backgroundColor: "#318BEC",
                      fontFamily: "urbanist",
                      textTransform: "capitalize",
                      fontSize: "15px",
                    }}
                  >
                    Suggest an Offer
                  </Button>
                </MDBox>
                {loading && (
                  <MDBox
                    sx={{
                      color: "green",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Typography variant="body">
                      We are Fetching Suggestion for You...
                    </Typography>
                  </MDBox>
                )}
                {localRAMoment && (
                  <>
                    <MDBox sx={{ mt: 2 }}>
                      <Typography variant="body2" sx={{ mb: 1 }}>
                        Suggested Message:
                      </Typography>
                      <textarea
                        value={`${RAMomentsData || ""}${
                          requestGenericRequest?.business?.booking_link
                            ? `\n\nBook Now :- ${requestGenericRequest.business.booking_link}`
                            : ""
                        }`}
                        onChange={(e) => setRAMomentsData(e.target.value)}
                        style={{
                          width: "100%",
                          minHeight: "140px",
                          borderRadius: "8px",
                          padding: "10px",
                          border: "1px solid #ccc",
                        }}
                      />
                    </MDBox>

                    <Button
                      variant="contained"
                      size="medium"
                      onClick={handleSubmitforSendEmail}
                      sx={{
                        mt: 2,
                        color: "#fff",
                        cursor: "pointer",
                        borderRadius: "45px",
                        backgroundColor: "#318BEC",
                        fontFamily: "urbanist",
                        textTransform: "capitalize",
                        fontSize: "15px",
                      }}
                    >
                      Send Email
                    </Button>
                    {/* Actions */}
                    <MDBox
                      sx={{
                        mt: 3,
                        display: "flex",
                        flexDirection: {
                          xs: "column", // on mobile: column
                          sm: "row", // on tablet & up: row
                        },
                        gap: {
                          xs: 1,
                          sm: 7,
                        },
                        justifyContent: "start",
                        alignItems: "center",
                        // gap: 5,
                        // flexWrap: "wrap",
                      }}
                    >
                      {selectedUser.phoneNumber && (
                        <MDBox
                          sx={{
                            display: "flex",
                            gap: {
                              xs: 1,
                              sm: 7,
                            },
                            // flexWrap: "wrap",
                            justifyContent: "center",
                          }}
                        >
                          <Button
                            variant="contained"
                            size="medium"
                            sx={{
                              color: "#fff",
                              minWidth: 80,
                              cursor: "pointer",
                              borderRadius: "45px",
                              backgroundColor: "#318BEC",
                              fontFamily: "urbanist",
                              textTransform: "capitalize",
                              fontSize: "15px",
                            }}
                            startIcon={<PhoneIcon />}
                          >
                            Call
                          </Button>
                          <Button
                            variant="contained"
                            size="medium"
                            sx={{
                              color: "#fff",
                              minWidth: 80,
                              cursor: "pointer",
                              borderRadius: "45px",
                              backgroundColor: "#318BEC",
                              fontFamily: "urbanist",
                              textTransform: "capitalize",
                              fontSize: "15px",
                            }}
                            startIcon={<MessageIcon />}
                            onClick={handleMessageClick}
                          >
                            Message
                          </Button>
                        </MDBox>
                      )}

                      {selectedUser.emailAddress && (
                        <MDBox
                          sx={{
                            display: "flex",
                            gap: 1,
                            justifyContent: "center",
                          }}
                        >
                          <Button
                            variant="contained"
                            size="medium"
                            sx={{
                              color: "#fff",
                              minWidth: 80,
                              cursor: "pointer",
                              borderRadius: "45px",
                              backgroundColor: "#318BEC",
                              fontFamily: "urbanist",
                              textTransform: "capitalize",
                              fontSize: "15px",
                            }}
                            startIcon={<EmailIcon />}
                            onClick={handleEmailClick}
                          >
                            Email
                          </Button>
                        </MDBox>
                      )}
                    </MDBox>
                  </>
                )}
              </MDBox>
            </>
          )}
        </MDBox>
      </Modal>

      <Modal
        open={newtemplate}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <MDBox
          className="main_modals"
          sx={{
            position: "absolute",
            top: {
              xs: "50%",
              sm: "50%",
            },
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: {
              xs: "90%",
              sm: 400,
              md: 500,
            },
            bgcolor: "background.paper",
            boxShadow: 24,

            borderRadius: 2,
            maxHeight: "90vh",
            overflowY: "auto",
          }}
        >
          <MDBox
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "start",
              flexWrap: "wrap",
              gap: 1,
              px: 2,
              py: 1,
              borderBottom: "1px solid #E1EAFF",
              backgroundColor: "#348BEC",
            }}
          >
            <Typography
              variant="h5"
              component="h2"
              sx={{ wordBreak: "break-word", color: "#fff" }}
            >
              Create a new Offer Template
            </Typography>
            <IconButton
              className="closeIcon"
              sx={{ color: "#fff" }}
              onClick={handleClose}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </MDBox>

          <MDBox
            sx={{
              p: {
                xs: 2,
                sm: 3,
                md: 2,
              },
            }}
          >
            <MDBox mb={2}>
              <MDTypography
                variant="subtitle2"
                fontWeight="regular"
                sx={{ color: "#212121" }}
              >
                Select Offer
              </MDTypography>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                select
                fullWidth
                value={selectedTemplateId}
                onChange={handleTemplateSelect}
                variant="outlined"
                placeholder="Select offer"
                sx={{
                  py: 1.4,
                }}
              >
                {offersToShow.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.name} {offerData?.list?.length === 0 && "(Sample)"}
                  </MenuItem>
                ))}
              </Select>
            </MDBox>
            {/* Template Name */}
            <MDBox mb={2}>
              <MDTypography
                variant="subtitle2"
                fontWeight="regular"
                sx={{ color: "#212121" }}
              >
                Name <span style={{ color: "red" }}>*</span>
              </MDTypography>
              <MDInput
                type="text"
                placeholder="Enter template name"
                fullWidth
                name="name"
                value={templateData?.name}
                onChange={handleTemplateChange}
              />
            </MDBox>

            {/* Template Info */}
            <MDBox mb={3}>
              <MDTypography
                variant="subtitle2"
                fontWeight="regular"
                sx={{ color: "#212121" }}
              >
                Message <span style={{ color: "red" }}>*</span>
              </MDTypography>
              <MDInput
                type="text"
                placeholder="Enter template message"
                multiline
                rows={4}
                name="info"
                fullWidth
                value={
                  templateData?.info
                    ? `${templateData.info}${
                        requestGenericRequest?.business?.booking_link
                          ? `\n\nBook Now :- ${requestGenericRequest.business.booking_link}`
                          : ""
                      }`
                    : ""
                }
                // value={templateData?.info}
                onChange={handleTemplateChange}
              />
            </MDBox>

            {/* Submit Button */}
            <MDBox>
              <Button
                variant="contained"
                size="medium"
                sx={{
                  color: "#fff",
                  minWidth: 80,
                  cursor: "pointer",
                  borderRadius: "45px",
                  backgroundColor: "#318BEC",
                  fontFamily: "urbanist",
                  textTransform: "capitalize",
                  fontSize: "15px",
                }}
                onClick={handleSubmitTemplate}
              >
                Send offer to all
              </Button>
            </MDBox>
          </MDBox>
        </MDBox>
      </Modal>
    </MDBox>
  );
};

export default RaMoment;
